import { render, staticRenderFns } from "./marketing-record-dialog.vue?vue&type=template&id=7f66ab66&scoped=true"
import script from "./marketing-record-dialog.vue?vue&type=script&lang=js"
export * from "./marketing-record-dialog.vue?vue&type=script&lang=js"
import style0 from "./marketing-record-dialog.vue?vue&type=style&index=0&id=7f66ab66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66ab66",
  null
  
)

export default component.exports